<form [formGroup]="form" class="card-body p-4">
    <div class="mb-2">
        <label for="email" class="form-label">Email</label>
        <input formControlName="email" type="text" id="email" placeholder="Email" class="form-control">
    </div>
    <div class="mb-2">
        <label for="password" class="form-label">Password</label>
        <input formControlName="password" type="password" id="password" placeholder="Password" class="form-control">
    </div>
    @if(error) {
        <div class="mb-2">
            <span class="text-danger">{{error}}</span>
        </div>
    }
    <div class="text-center">
        @if(loading) {
            <button type="button" (click)="login()" class="btn btn-primary mt-3" autofocus disabled>
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Login
            </button>
        }
        @else {
            <button type="button" (click)="login()" class="btn btn-primary mt-3" autofocus>
                Login
            </button>
        }
    </div>
</form>